(function($){
  const DEFAULT_MSG = {
    timeHeader:'time.header',
    hintDrag:'hint.drag',
    clearAll:'btn.clearAll',
    remove:'btn.remove',
    weekdays: { // ISO 1..7
      "1":"weekday.mon","2":"weekday.tue","3":"weekday.wed","4":"weekday.thu","5":"weekday.fri","6":"weekday.sat","7":"weekday.sun"
    }
  };
  const DEFAULT_LABELS = { // Fallback-Lookups, falls i18n-URL nicht erreichbar ist
    "time.header":"Zeit",
    "hint.drag":"Trainingszeiten festlegen: Ziehen Sie innerhalb der verfügbaren Bereiche, um auswählbare Zeiten zu markieren.",
    "btn.clearAll":"Alle löschen",
    "btn.remove":"Entfernen",
    "legend.available":"Verfügbar",
    "legend.selected":"Festgelegt",
    "legend.unavailable":"Nicht auswählbar",
    "weekday.mon":"Montag","weekday.tue":"Dienstag","weekday.wed":"Mittwoch","weekday.thu":"Donnerstag","weekday.fri":"Freitag","weekday.sat":"Samstag","weekday.sun":"Sonntag"
  };

  function hourHeightPx(){ return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--hour-height'))||48; }
  function timeToMin(t){
    if(t==null) return 0;
    if(t==="24:00" || t==="24:00:00") return 1440;
    const [h,m]=t.split(':').map(Number); return h*60+m;
  }
  function minToTime(m){ const h=Math.floor(m/60), mm=m%60; return (h<10?'0':'')+h+':'+(mm<10?'0':'')+mm; }
  function minutesToPixels(min){ return (min/60)*hourHeightPx(); }
  function pixelsToMinutes(px){ return px/hourHeightPx()*60; }

  // Merge adjacent / overlapping avail spans (server may emit two segments for a wrap range,
  // e.g. moduleBegin=moduleEnd=07:00 -> [{00:00,07:00},{07:00,24:00}]; the user expects to
  // be able to drag across the 07:00 boundary as one continuous block).
  function mergeAvailSpans(spans){
    if(!spans?.length) return [];
    const sorted=spans.map(s=>({start:timeToMin(s.start), end:timeToMin(s.end)}))
                      .filter(s=>s.end>s.start)
                      .sort((a,b)=>a.start-b.start);
    const out=[sorted[0]];
    for(let i=1;i<sorted.length;i++){
      const last=out[out.length-1], cur=sorted[i];
      if(cur.start<=last.end) last.end=Math.max(last.end, cur.end);
      else out.push(cur);
    }
    return out.map(s=>({start:minToTime(s.start), end:minToTime(s.end)}));
  }

  // Snapping ist am anchorOff (Minuten-Offset des Modul-Beginns, z.B. 30 bei 07:30/60min)
  // verankert: der Server akzeptiert nur Zeiten auf dem Raster moduleBegin + k*minorClock,
  // ein reines Mitternachts-Raster erzeugt dort ungültige Zeiten.
  function mergeIntervals(arr, snap, anchorOff){
    if(!arr?.length) return [];
    const off=anchorOff||0;
    const snapMin=v=>off+Math.round((v-off)/snap)*snap;
    const sorted=arr.map(x=>({startMin:snapMin(x.startMin), endMin:snapMin(x.endMin)})).filter(x=>x.endMin>x.startMin).sort((a,b)=>a.startMin-b.startMin);
    const out=[sorted[0]]; for(let i=1;i<sorted.length;i++){ const last=out[out.length-1], cur=sorted[i]; if(cur.startMin<=last.endMin) last.endMin=Math.max(last.endMin, cur.endMin); else out.push(cur); }
    return out;
  }

  function Plugin($el, opts){
    this.$root=$el.addClass('otr-root');
    this.opt=$.extend(true,{
      moduleId:null,
      fetchUrl:null,      // function(trainerIds[]) => url
      i18nUrl:null,       // URL -> JSON (siehe Beispiel unten)
      css:{
        clearBtn:'btn btn-sm btn-outline-secondary',
        closeBtn:'rb-close',
        spinner:'spinner-border'
      },
      messages:{},        // overrides mit Codes oder Plaintext
      labels:{},          // wenn du fertige Texte ohne Codes liefern willst
      startTime:'00:00',  // Spalten-Anfang (Tagesgrenze, default 00:00)
      endTime:'24:00',    // Spalten-Ende  (Tagesgrenze, default 24:00)
      anchorTime:null,    // Raster-Anker (Modul-Beginn); null = Mitternacht
      compress:false,     // wenn true: Spaltenrange = Union der Avail-Wochentages-Öffnungszeiten
      tickStep:15,        // Minuten: Raster/Snapping/Internallogik
	  viewStep:30,        // Minuten: sichtbare Zeitschritte (Labels + Linien)
      selections:[],
	  selectables:[],
	  disabled:false,
	  modelName:'offerTimeWindows', // für Hidden Inputs
	  layout:'auto'       // 'auto' | 'columns' | 'rows' — rows: 1 Wochentag pro Zeile (Mobile)
    }, opts||{});

    // Messages/Labels
    this.msg=$.extend(true, {}, DEFAULT_MSG, this.opt.messages);
    this.labels=$.extend({}, DEFAULT_LABELS, this.opt.labels);

    this.state={
      DAY_START_MIN: timeToMin(this.opt.startTime),
      DAY_END_MIN:   timeToMin(this.opt.endTime),
	  SLOT_SIZE_MIN: (this.opt.tickStep != null ? this.opt.tickStep : (this.opt.slotSize != null ? this.opt.slotSize : 15)),
	  VIEW_STEP_MIN: (this.opt.viewStep != null ? this.opt.viewStep : 30),
	  ANCHOR_MIN: timeToMin(this.opt.anchorTime || '00:00') % 1440,
      dayCols:{}, restricts:{1:[],2:[],3:[],4:[],5:[],6:[],7:[]},
      avails:{1:[],2:[],3:[],4:[],5:[],6:[],7:[]},
      layoutRows:false,
      dragging:null,
      resizing:null // {day, idx, edge:'top'|'bottom', startAbs, origStart, origEnd, $block}
    };
	
	if (this.state.VIEW_STEP_MIN % this.state.SLOT_SIZE_MIN !== 0) { try { console.warn('[OTR] viewStep sollte Vielfaches von tickStep sein.'); } catch(e) {} }

    this.DAYS = [1,2,3,4,5,6,7]; // ISO
	this.DAY_NAMES = ["MONDAY","TUESDAY","WEDNESDAY","THURSDAY","FRIDAY","SATURDAY","SUNDAY"];

    this.init();
  }

  Plugin.prototype={
    /* ====================== Public API ====================== */
    setSelections(list){
      this.state.restricts={1:[],2:[],3:[],4:[],5:[],6:[],7:[]};
      (list||[]).forEach(it=>{
        if(!it?.weekday) return;
        this._addRestriction(it.weekday, timeToMin(it.start), timeToMin(it.end), false);
      });
      this._renderAllRestrictions(); this._refreshHidden();
    },
    getSelections(){
      const out=[]; for(const d of this.DAYS){ (this.state.restricts[d]||[]).forEach(iv=> out.push({weekday:d, start:minToTime(iv.startMin), end:minToTime(iv.endMin)})); }
      return out;
    },
    refreshAvailabilities(trainerIds){ return this._fetchTrainerAvailabilities(trainerIds); },
    setBounds({start,end}){ if(start) this.state.DAY_START_MIN=timeToMin(start); if(end) this.state.DAY_END_MIN=timeToMin(end); this._buildGrid(); this._renderAvailabilities(); this._renderAllRestrictions(); },
    setDisabled(disabled){
      this.opt.disabled=!!disabled;
      this._buildSkeleton();
      this._buildGrid();
      this._renderAvailabilities();
      this._renderAllRestrictions();
      this._refreshHidden();
    },
    
	// Back-Compat: alter Name bleibt als Alias
	setSlotSize: function(min){ this.setTickStep(min); },
	setTickStep: function(min){
		var m = Math.max(1, parseInt(min,10)||15);
		this.state.SLOT_SIZE_MIN = m;
		if (this.state.VIEW_STEP_MIN % m !== 0) { try { console.warn('[OTR] viewStep sollte Vielfaches von tickStep sein.'); } catch(e) {} }
			for (var i=0; i<this.DAYS.length; i++){
				var d=this.DAYS[i];
				this.state.restricts[d] = mergeIntervals(this.state.restricts[d], this.state.SLOT_SIZE_MIN, this._anchorOff());
			}
			this._renderAllRestrictions();
			this._refreshHidden();
		},

	setViewStep: function(min){
		var m = Math.max(1, parseInt(min,10)||30);
		this.state.VIEW_STEP_MIN = m;
		if (m % this.state.SLOT_SIZE_MIN !== 0) { try { console.warn('[OTR] viewStep sollte Vielfaches von tickStep sein.'); } catch(e) {} }
		// Nur Grid neu zeichnen, Restriktionen bleiben
		this._buildGrid();
		this._renderAvailabilities();
		this._renderAllRestrictions();
	},
	
    destroy(){ $(document).off('.otr'); $(window).off('.otr'); this.$root.empty().removeClass('otr-root').removeData('offerTimeRestrictor'); },

    /* ====================== Init ====================== */
    async init(){
      await this._loadMessages();
      this._buildSkeleton();
	  this.state.avails=this.opt.selectables||{1:[],2:[],3:[],4:[],5:[],6:[],7:[]};
	  this._normalizeAvails();
	  this._applyCompression();
      this._buildGrid();
      this._bindInteractions();
	  this._renderAvailabilities();
      this.setSelections(this.opt.selections);
    },

    // Merge adjacent/overlapping avails per day so the UI lets the user drag across
    // server-side splits (e.g. wrap ranges encoded as two segments).
    _normalizeAvails(){
      for(const d of this.DAYS){
        this.state.avails[d] = mergeAvailSpans(this.state.avails[d]||[]);
      }
    },

    /* ====================== Compression ======================
     * Wenn opt.compress=true: leite Spaltenrange (DAY_START/DAY_END_MIN) aus der Union
     * der per-Wochentag avails ab. Snap an viewStep, damit die Tickleiste sauber bleibt.
     * Sonst: behalte die konfigurierten Tagesgrenzen.
     */
    _applyCompression(){
      if(!this.opt.compress) return false;
      let minStart=Infinity, maxEnd=-Infinity;
      for(const d of this.DAYS){
        for(const a of (this.state.avails[d]||[])){
          const s=timeToMin(a.start), e=timeToMin(a.end);
          if(s<minStart) minStart=s;
          if(e>maxEnd)   maxEnd=e;
        }
      }
      if(!isFinite(minStart) || !isFinite(maxEnd) || maxEnd<=minStart) return false;
      const step=this.state.VIEW_STEP_MIN || 30;
      // am Anker ausrichten, damit Zeitleiste und Slot-Raster zusammenpassen (z.B. 07:30, 08:30, ...)
      const off=this.state.ANCHOR_MIN % step;
      minStart=Math.max(0,    off+Math.floor((minStart-off)/step)*step);
      maxEnd  =Math.min(1440, off+Math.ceil((maxEnd-off)/step)*step);
      this.state.DAY_START_MIN=minStart;
      this.state.DAY_END_MIN  =maxEnd;
      return true;
    },

    /* ====================== UI Build ====================== */
    _t(code){ return this.labels[code] || code; },
    _weekdayLabel(i){ const code=this.msg.weekdays[String(i)] || String(i); return this._t(code); },

    _buildSkeleton(){
      this.$root.html(`
        <div class="d-flex align-items-center mb-2">
          <small class="text-muted mr-2">${this._t(this.msg.hintDrag)}</small>
          ${this.opt.disabled ? '' : `<button type="button" class="${this.opt.css.clearBtn}" data-otr="clear">${this._t(this.msg.clearAll)}</button>`}
        </div>
        <div class="otr-legend">
          <span class="otr-legend__item"><span class="otr-legend__swatch otr-legend__swatch--available"></span>${this._t("legend.available")}</span>
          <span class="otr-legend__item"><span class="otr-legend__swatch otr-legend__swatch--selected"></span>${this._t("legend.selected")}</span>
          <span class="otr-legend__item"><span class="otr-legend__swatch otr-legend__swatch--unavailable"></span>${this._t("legend.unavailable")}</span>
        </div>
        <div class="position-relative">
          <div class="week-grid border" id="otrGrid"></div>
          <div class="grid-loading d-none"><div class="${this.opt.css.spinner}" role="status" aria-label="..."></div></div>
        </div>
        <div id="otrHidden"></div>
      `);
      this.$grid=this.$root.find('#otrGrid'); this.$loading=this.$root.find('.grid-loading'); this.$hidden=this.$root.find('#otrHidden');
      this.$root.toggleClass('otr-disabled', this.opt.disabled);

      const self=this;
      this.$root.find('[data-otr="clear"]').on('click.otr', function(){
        if(self.opt.disabled) return;
        for(const d of self.DAYS){ self.state.restricts[d]=[]; self._renderDayRestrictions(d); }
        self._refreshHidden();
      });
    },

    _buildGrid(){
      this.state.layoutRows=this._computeLayout();
      this.$grid.empty().toggleClass('otr-rows', this.state.layoutRows);
      if(this.state.layoutRows) this._buildGridRows();
      else this._buildGridColumns();
    },

    // Zeilen-Layout: 1 Wochentag pro Zeile, Zeitachse horizontal (Mobile)
    _buildGridRows(){
      const s=this.state, $wrap=this.$grid;
      const total=s.DAY_END_MIN-s.DAY_START_MIN;

      // Beschriftungsschritt so wählen, dass die Zeit-Labels nicht kollidieren
      const trackW=Math.max(0,(this.$root.width()||0)-56);
      const pxPerMin=trackW>0 ? trackW/total : 0.3;
      let labelStep=Math.max(s.VIEW_STEP_MIN, 60);
      while(labelStep*pxPerMin<36 && labelStep<total) labelStep*=2;

      const $head=$('<div class="wg-row wg-row-head"></div>');
      $head.append(`<div class="wg-row-label">${this._t(this.msg.timeHeader)}</div>`);
      const $scale=$('<div class="wg-time-row"></div>');
      for(let m=s.DAY_START_MIN; m<s.DAY_END_MIN; m+=labelStep){
        $scale.append(`<div class="tick" style="left:${((m-s.DAY_START_MIN)/total*100).toFixed(3)}%">${minToTime(m)}</div>`);
      }
      $head.append($scale); $wrap.append($head);

      const stepPct=(s.VIEW_STEP_MIN/total*100).toFixed(4);
      for(const d of this.DAYS){
        const $row=$('<div class="wg-row"></div>');
        $row.append(`<div class="wg-row-label">${this._weekdayLabel(d)}</div>`);
        const $col=$(`<div class="wg-day-col" data-day="${d}"></div>`).css({
          'background':'linear-gradient(to right, rgba(0,0,0,.06) 1px, transparent 1px)',
          'background-size': stepPct+'% 100%'
        });
        $row.append($col); $wrap.append($row); s.dayCols[d]=$col;
      }
    },

    _buildGridColumns(){
      const s=this.state, $wrap=this.$grid;

      // Header
      const $head=$('<div class="wg-head"></div>');
      $head.append(`<div class="cell text-muted d-flex align-items-center justify-content-center">${this._t(this.msg.timeHeader)}</div>`);
      for(const d of this.DAYS){ $head.append(`<div class="cell d-flex align-items-center pl-1">${this._weekdayLabel(d)}</div>`); }
      $wrap.append($head);

      // Body
      const $body=$('<div class="wg-body"></div>');

      // Start/End nicht volle Stunde: erster Tick = Startzeit
	  const $timeCol=$('<div class="wg-time-col"></div>');
	  // Zeitleiste in viewStep-Minuten (Labels); erster Tick = Startzeit
	  var start = s.DAY_START_MIN, end = s.DAY_END_MIN;
	  var step  = s.VIEW_STEP_MIN;
	  var stepPx = minutesToPixels(step);
	  for (var m = start; m < end; m += step) {
	  	var cls = (m % 60 === 0) ? 'tick tick-hour' : 'tick';
	  	// Tick-Höhe dynamisch passend zum viewStep
	  	$timeCol.append('<div class="' + cls + '" style="height:'+ stepPx +'px;">' + minToTime(m) + '</div>');
	  }
      $body.append($timeCol);

      const relTotal=end-start;
	  const offsetPx = minutesToPixels(s.DAY_START_MIN % step);
      for(const d of this.DAYS){
        const $col=$(`<div class="wg-day-col" data-day="${d}"></div>`);
        $col.css({
          'min-height': minutesToPixels(relTotal)+'px',
		  'background': 'linear-gradient(to bottom, rgba(0,0,0,.06) 1px, transparent 1px)',
		  'background-size': '100% '+ stepPx +'px',
		  'background-position': '0 ' + (stepPx - offsetPx) + 'px'
        });
        $body.append($col); this.state.dayCols[d]=$col;
      }
      $wrap.append($body);
    },

    _renderAvailabilities(){
      for(const d of this.DAYS){
        const $col=this.state.dayCols[d]; $col.find('.avail-block').remove();
        (this.state.avails[d]||[]).forEach(span=>{
          $col.append($('<div class="avail-block"></div>').css(this._spanCss(timeToMin(span.start), timeToMin(span.end))));
        });
      }
    },

    _renderDayRestrictions(day){
      const s=this.state, $col=s.dayCols[day]; $col.find('.restrict-block').remove();
      (s.restricts[day]||[]).forEach((it, idx)=>{
        const $b=$(`
          <div class="restrict-block" data-idx="${idx}">
            ${this.opt.disabled ? '' : `<button type="button" class="${this.opt.css.closeBtn}" aria-label="${this._t(this.msg.remove)}">&times;</button>`}
            ${this.opt.disabled ? '' : '<div class="rb-handle rb-top"></div>'}
            ${this.opt.disabled ? '' : '<div class="rb-handle rb-bottom"></div>'}
            <div class="rb-label">${minToTime(it.startMin)} – ${minToTime(it.endMin)}</div>
          </div>
        `).css(this._spanCss(it.startMin, it.endMin));
        it.$el=$b; $col.append($b);
      });
    },
    _renderAllRestrictions(){ for(const d of this.DAYS) this._renderDayRestrictions(d); },

    /* ====================== Layout & Coordinates ====================== */
    _computeLayout(){
      if(this.opt.layout==='rows') return true;
      if(this.opt.layout==='columns') return false;
      const w=this.$root.width()||0;
      if(w>0 && w<640) return true; // schmale Container (Mobile): 1 Wochentag pro Zeile
      // Touch als primäre Eingabe -> ebenfalls Zeilen-Layout: das Backend hat kein
      // responsives Viewport-Meta (virtueller ~980px-Viewport auf dem Handy), die
      // Breite allein erkennt Mobilgeräte dort nicht.
      return !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    },

    // CSS-Position eines Zeitspans: Spalten-Layout top/height (px), Zeilen-Layout left/width (%)
    _spanCss(sMin, eMin){
      const s=this.state;
      const a=Math.max(s.DAY_START_MIN, Math.min(sMin, s.DAY_END_MIN));
      const b=Math.max(s.DAY_START_MIN, Math.min(eMin, s.DAY_END_MIN));
      if(s.layoutRows){
        const total=(s.DAY_END_MIN-s.DAY_START_MIN)||1;
        return {left:((a-s.DAY_START_MIN)/total*100)+'%', width:((b-a)/total*100)+'%'};
      }
      return {top:minutesToPixels(a-s.DAY_START_MIN), height:minutesToPixels(b-a)};
    },

    // Pointer-Position -> absolute Minuten (ungesnappt), achsenabhängig
    _evtToMin(colEl, evt){
      const s=this.state, rect=colEl.getBoundingClientRect();
      const oe=evt.originalEvent||evt;
      let rel;
      if(s.layoutRows){
        const total=s.DAY_END_MIN-s.DAY_START_MIN;
        rel=(oe.clientX-rect.left)/(rect.width||1)*total;
      }else{
        rel=pixelsToMinutes(oe.clientY-rect.top);
      }
      return s.DAY_START_MIN+Math.round(rel);
    },

    // Liegt der Pointer nahe an der Kante eines bestehenden Blocks? Die Handles sind
    // fingerbreit verfehlbar — ein Touch knapp daneben soll resizen statt neu zeichnen.
    _findNearbyEdge(day, colEl, evt){
      const s=this.state, rect=colEl.getBoundingClientRect();
      const oe=evt.originalEvent||evt;
      const total=(s.DAY_END_MIN-s.DAY_START_MIN)||1;
      const pxPerMin=s.layoutRows ? (rect.width||1)/total : hourHeightPx()/60;
      const posPx=s.layoutRows ? (oe.clientX-rect.left) : (oe.clientY-rect.top);
      const THRESH_PX=18;
      let best=null;
      (s.restricts[day]||[]).forEach((it,idx)=>{
        const dS=Math.abs(posPx-(it.startMin-s.DAY_START_MIN)*pxPerMin);
        const dE=Math.abs(posPx-(it.endMin-s.DAY_START_MIN)*pxPerMin);
        if(dS<=THRESH_PX && (!best||dS<best.dist)) best={idx, edge:'top', dist:dS};
        if(dE<=THRESH_PX && (!best||dE<best.dist)) best={idx, edge:'bottom', dist:dE};
      });
      return best;
    },

    /* ====================== Hidden ====================== */
    _refreshHidden(){
      const $hf=this.$hidden.empty(); let i=0;
      for(const d of this.DAYS){ (this.state.restricts[d]||[]).forEach(iv=>{
		
		const dayValue = this.DAY_NAMES[d-1];
		
        $hf.append(`<input type="hidden" name="${this.opt.modelName}[${i}].dayOfWeek" value="${dayValue}">`);
        $hf.append(`<input type="hidden" name="${this.opt.modelName}[${i}].fromTime" value="${minToTime(iv.startMin)}">`);
        $hf.append(`<input type="hidden" name="${this.opt.modelName}[${i}].toTime" value="${minToTime(iv.endMin)}">`);
        i++;
      }) }
    },

    /* ====================== i18n ====================== */
    async _loadMessages(){
      if(!this.opt.i18nUrl) return;
      try{
        const resp = await $.getJSON(this.opt.i18nUrl);
        if(resp?.messages) this.msg=$.extend(true, {}, this.msg, resp.messages);
        if(resp?.labels)   this.labels=$.extend({}, this.labels, resp.labels);
      }catch(e){ /* Fallbacks bleiben */ }
    },

    /* ====================== Fetch Avails ====================== */
    async _fetchTrainerAvailabilities(trainerIds){
      let url;
      if(typeof this.opt.fetchUrl==='function'){ url=this.opt.fetchUrl(trainerIds); }
      else {
        url=this.opt.fetchUrl;
      }
      this._toggleLoading(true);
      try{
        const resp = await $.getJSON(url);
        let byDay = resp;

        this.state.avails=byDay;
        this._normalizeAvails();
        if(this._applyCompression()) this._buildGrid();
        this._renderAvailabilities();
        this._reconcileRestrictionsWithAvail(); this._refreshHidden();
      } finally { this._toggleLoading(false); }
    },

    /* ====================== Restrictions ====================== */
    _addRestriction(day, sMin, eMin, doMerge=true){
      const st=this.state;
      if(!st.restricts[day]) st.restricts[day]=[];
      st.restricts[day].push({startMin:sMin, endMin:eMin});
      if(doMerge) st.restricts[day]=mergeIntervals(st.restricts[day], st.SLOT_SIZE_MIN, this._anchorOff());
      this._renderDayRestrictions(day);
    },
    _removeRestriction(day, idx){
      const arr=this.state.restricts[day]||[];
      if(arr[idx]?.$el) arr[idx].$el.remove();
      arr.splice(idx,1); this._renderDayRestrictions(day); this._refreshHidden();
    },
    // Raster-Snapping, verankert am Modul-Beginn (siehe mergeIntervals)
    _anchorOff(){ return this.state.ANCHOR_MIN % this.state.SLOT_SIZE_MIN; },
    _snap(v){ const off=this._anchorOff(), t=this.state.SLOT_SIZE_MIN; return off+Math.round((v-off)/t)*t; },
    _snapCeil(v){ const off=this._anchorOff(), t=this.state.SLOT_SIZE_MIN; return off+Math.ceil((v-off)/t)*t; },
    _snapFloor(v){ const off=this._anchorOff(), t=this.state.SLOT_SIZE_MIN; return off+Math.floor((v-off)/t)*t; },
    _spanInsideAnyAvail(day, sMin, eMin){
      const list=this.state.avails[day]||[];
      return list.some(a=> timeToMin(a.start)<=sMin && timeToMin(a.end)>=eMin);
    },
    _clampToAvailability(day, sMin, eMin){
      const list=this.state.avails[day]||[];
      for(const a of list){ const as=timeToMin(a.start), ae=timeToMin(a.end); const cs=Math.max(sMin,as), ce=Math.min(eMin,ae); if(cs<ce) return {s:cs,e:ce}; }
      return null;
    },
    _reconcileRestrictionsWithAvail(){
      for(let d=1; d<=7; d++){
        const keep=[];
        for(const it of (this.state.restricts[d]||[])){
          if(this._spanInsideAnyAvail(d, it.startMin, it.endMin)) keep.push(it);
          else { const c=this._clampToAvailability(d, it.startMin, it.endMin); if(c) keep.push({startMin:this._snapCeil(c.s), endMin:this._snapFloor(c.e)}); }
        }
        this.state.restricts[d]=mergeIntervals(keep, this.state.SLOT_SIZE_MIN, this._anchorOff());
        this._renderDayRestrictions(d);
      }
    },

    /* ====================== Interactions (Create, Remove, Resize) ====================== */
    _bindInteractions(){
      const self=this;

      // Pointer Events vereinheitlichen Maus + Touch; Fallback auf Maus-Events für Altbrowser.
      // Touch braucht zusätzlich touch-action:none auf .wg-day-col (SCSS), sonst scrollt der Browser statt zu draggen.
      const hasPointer = ('PointerEvent' in window);
      const EV_DOWN = hasPointer ? 'pointerdown.otr' : 'mousedown.otr';
      const EV_MOVE = hasPointer ? 'pointermove.otr' : 'mousemove.otr';
      const EV_UP   = hasPointer ? 'pointerup.otr'   : 'mouseup.otr';

      function native(evt){ return evt.originalEvent || evt; }
      function isPrimaryButton(evt){
        const oe=native(evt);
        if(oe.isPrimary===false) return false; // zweiter Finger bei Multi-Touch
        return oe.button===undefined || oe.button===0;
      }
      function samePointer(evt, id){
        if(id===undefined) return true;
        return native(evt).pointerId===id;
      }
      function capturePointer(el, evt){
        const oe=native(evt);
        if(hasPointer && oe.pointerId!==undefined && el.setPointerCapture){
          try{ el.setPointerCapture(oe.pointerId); }catch(e){ /* Element ggf. nicht mehr im DOM */ }
        }
      }

      // Create via Drag
      this.$grid.on(EV_DOWN, '.wg-day-col', function(evt){
        if(self.opt.disabled) return;
        if(!isPrimaryButton(evt)) return;
        if(self.state.dragging || self.state.resizing) return;
        if($(evt.target).closest('.rb-close,.rb-handle').length) return;
        const day=parseInt(this.dataset.day,10);

        // Touch: nahe einer Blockkante -> Resize statt Neuanlegen (Handles sind mit dem Finger leicht verfehlbar)
        if(native(evt).pointerType && native(evt).pointerType!=='mouse'){
          const hit=self._findNearbyEdge(day, this, evt);
          if(hit){
            const item=self.state.restricts[day][hit.idx];
            if(item){
              self.state.resizing={
                day, idx:hit.idx, edge:hit.edge, $block:item.$el,
                origStart:item.startMin, origEnd:item.endMin,
                pointerId:native(evt).pointerId
              };
              capturePointer(this, evt);
              evt.preventDefault();
              return;
            }
          }
        }

		const relMin = self._evtToMin(this, evt);
        const snapped = self._snap(relMin);
        if(!self._spanInsideAnyAvail(day, snapped, snapped+self.state.SLOT_SIZE_MIN)) return;

        const $ghost=$('<div class="drag-ghost"></div>');
        $(this).append($ghost.css(self._spanCss(snapped, snapped)));
        self.state.dragging={day, startAbs:snapped, ghost:$ghost, pointerId:native(evt).pointerId};
        capturePointer(this, evt); // Moves bleiben auf der Startspalte, auch wenn der Finger abdriftet
        evt.preventDefault();
      });

      this.$grid.on(EV_MOVE, '.wg-day-col', function(evt){
        if(self.opt.disabled) return;
        const st=self.state.dragging; if(!st) return;
        if(!samePointer(evt, st.pointerId)) return;
        const day=parseInt(this.dataset.day,10); if(day!==st.day) return;
		const rel = self._evtToMin(this, evt);
        const snapped=self._snap(rel);
        st.ghost.css(self._spanCss(Math.min(snapped, st.startAbs), Math.max(snapped, st.startAbs)));
      });

      $(document).on(EV_UP, function(evt){
        if(self.opt.disabled) return;
        const st=self.state.dragging; if(st && samePointer(evt, st.pointerId)){
          const day=st.day, $col=self.state.dayCols[day];
          const endAbs=self._evtToMin($col[0], evt);
          st.ghost.remove(); self.state.dragging=null;
          let s=Math.min(st.startAbs,endAbs), e=Math.max(st.startAbs,endAbs);
          if(e-s<self.state.SLOT_SIZE_MIN) return;
          if(!self._spanInsideAnyAvail(day, s, e)){
            const c=self._clampToAvailability(day, s, e); if(!c) return;
            // nach dem Clampen nach innen snappen, sonst rundet der Merge über den Modul-Rand hinaus
            s=self._snapCeil(c.s); e=self._snapFloor(c.e);
            if(e-s<self.state.SLOT_SIZE_MIN) return;
          }
          self._addRestriction(day, s, e, true); self._refreshHidden();
        }

        // RESIZE Enden
        const rz=self.state.resizing; if(rz && samePointer(evt, rz.pointerId)){
          self.state.resizing=null; // Commit war schon live beim Move; jetzt mergen + rendern + hidden
          self.state.restricts[rz.day]=mergeIntervals(self.state.restricts[rz.day], self.state.SLOT_SIZE_MIN, self._anchorOff());
          self._renderDayRestrictions(rz.day); self._refreshHidden();
        }
      });

      // Abbruch durch den Browser (z.B. Geste wird doch als Scroll interpretiert): Drag verwerfen
      if(hasPointer){
        $(document).on('pointercancel.otr', function(evt){
          const st=self.state.dragging; if(st && samePointer(evt, st.pointerId)){
            st.ghost.remove(); self.state.dragging=null;
          }
          const rz=self.state.resizing; if(rz && samePointer(evt, rz.pointerId)){
            const arr=self.state.restricts[rz.day];
            if(arr && arr[rz.idx]){ arr[rz.idx].startMin=rz.origStart; arr[rz.idx].endMin=rz.origEnd; }
            self.state.resizing=null;
            self._renderDayRestrictions(rz.day);
          }
        });
      }

      // Entfernen via "x"
      this.$grid.on('click.otr', '.rb-close', function(evt){
        if(self.opt.disabled) return;
        evt.stopPropagation();
        const $b=$(this).closest('.restrict-block'); const day=parseInt($b.closest('.wg-day-col').data('day'),10); const idx=parseInt($b.attr('data-idx'),10);
        self._removeRestriction(day, idx);
      });

      // Resize Start
      this.$grid.on(EV_DOWN, '.rb-handle', function(evt){
        if(self.opt.disabled) return;
        if(!isPrimaryButton(evt)) return;
        if(self.state.dragging || self.state.resizing) return;
        const $b=$(this).closest('.restrict-block');
        const day=parseInt($b.closest('.wg-day-col').data('day'),10);
        const idx=parseInt($b.attr('data-idx'),10);
        const edge=$(this).hasClass('rb-top') ? 'top' : 'bottom';
        const item=self.state.restricts[day][idx]; if(!item) return;

        self.state.resizing={
          day, idx, edge, $block:$b,
          origStart:item.startMin, origEnd:item.endMin,
          pointerId:native(evt).pointerId
        };
        capturePointer(this, evt);
        evt.preventDefault();
      });

      // Resize Move (auf Spalte, damit offsetY stimmt)
      this.$grid.on(EV_MOVE, '.wg-day-col', function(evt){
        if(self.opt.disabled) return;
        const rz=self.state.resizing; if(!rz) return;
        if(!samePointer(evt, rz.pointerId)) return;
        const day=parseInt(this.dataset.day,10); if(day!==rz.day) return;

		// Position relativ zur Spalte ermitteln, sonst springt das Start-Handle
		const rel=self._evtToMin(this, evt);
        const snapped=self._snap(rel);

        // neue Grenzen
        let ns=rz.origStart, ne=rz.origEnd;
        if(rz.edge==='top') ns=Math.min(snapped, ne - self.state.SLOT_SIZE_MIN);
        else                ne=Math.max(snapped, ns + self.state.SLOT_SIZE_MIN);

        // Clamp an Availability (nur am jeweiligen Rand); danach nach innen snappen,
        // damit der geclampte Rand auf dem Modul-Raster bleibt
        const clamp=self._clampToAvailabilityAtEdge(day, ns, ne, rz.edge);
        if(!clamp) return; // kein gültiger Schnitt
        ns=self._snapCeil(clamp.s); ne=self._snapFloor(clamp.e);
        if(ne-ns<self.state.SLOT_SIZE_MIN) return;

        // live anwenden
        const arr=self.state.restricts[day]; arr[rz.idx].startMin=ns; arr[rz.idx].endMin=ne;

        // Block visuell anpassen + Label aktualisieren
        rz.$block.css(self._spanCss(ns, ne)).find('.rb-label').text(`${minToTime(ns)} – ${minToTime(ne)}`);
      });

      // Layout bei Größenänderung neu bewerten (Spalten <-> Zeilen); im Zeilenmodus
      // hängt auch der Zeitachsen-Beschriftungsschritt an der Breite.
      let resizeTimer=null;
      $(window).on('resize.otr', function(){
        clearTimeout(resizeTimer);
        resizeTimer=setTimeout(function(){
          if(self.state.dragging || self.state.resizing) return;
          const rows=self._computeLayout();
          if(rows!==self.state.layoutRows || rows){
            self._buildGrid(); self._renderAvailabilities(); self._renderAllRestrictions();
          }
        },150);
      });
    },

    // Spezielles Clamping: nur den Rand an die nächstliegende Availability anpassen
    _clampToAvailabilityAtEdge(day, ns, ne, edge){
      const list=this.state.avails[day]||[];
      if(!list.length) return null;
      if(edge==='top'){
        // finde ein Availability-Fenster, das [ns,ne] abdeckt oder dessen Ende >= ns
        for(const a of list){
          const as=timeToMin(a.start), ae=timeToMin(a.end);
          if(ae<=ns) continue;
          const cs=Math.max(ns, as), ce=Math.min(ne, ae);
          if(cs<ce) return {s:cs, e:ce};
        }
      } else {
        for(const a of list){
          const as=timeToMin(a.start), ae=timeToMin(a.end);
          if(as>=ne) continue;
          const cs=Math.max(ns, as), ce=Math.min(ne, ae);
          if(cs<ce) return {s:cs, e:ce};
        }
      }
      return null;
    },

    _toggleLoading(show){ this.$loading.toggleClass('d-none', !show); }
  };

  $.fn.offerTimeRestrictor=function(optionsOrMethod){
    const args=[].slice.call(arguments,1);
    return this.each(function(){
      const $this=$(this); let inst=$this.data('offerTimeRestrictor');
      if(!inst){
        if(typeof optionsOrMethod==='string') throw new Error('offerTimeRestrictor not initialized');
        inst=new Plugin($this, optionsOrMethod||{}); $this.data('offerTimeRestrictor', inst);
      }else if(typeof optionsOrMethod==='string' && typeof inst[optionsOrMethod]==='function'){
        inst[optionsOrMethod].apply(inst, args);
      }
    });
  };
})(jQuery);
